import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';
import { CircularProgress, Grid } from '@material-ui/core';
import * as ROUTES from '../../../constants/routes';
import { Context, ContextProvider } from './store';
import { Body1 } from './blocks';
import { colors } from '@/styles';

function SsoCallback() {
    const { errors, loading } = useContext(Context);

    return (
        <Grid container direction="column">
            <Grid container direction="row">
                <Grid
                    container
                    direction="column"
                    css={css`
                        margin-top: 128px;
                    `}
                >
                    {errors?.auth ? (
                        <>
                            <Grid
                                container
                                direction="row"
                                css={css`
                                    justify-content: center;
                                    margin-bottom: 32px;
                                `}
                            >
                                <Body1
                                    css={css`
                                        color: ${colors.reds.primary};
                                    `}
                                >
                                    {errors.auth}
                                </Body1>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                css={css`
                                    justify-content: center;
                                `}
                            >
                                <Link to={ROUTES.SIGNIN}>
                                    <b>Back to Sign In</b>
                                </Link>
                            </Grid>
                        </>
                    ) : loading?.init ? (
                        <>
                            <CircularProgress />
                            <p style={{ marginTop: '1rem' }}>Signing-in...</p>
                        </>
                    ) : null}
                </Grid>
            </Grid>
        </Grid>
    );
}

const withContext = (Component) => (props) =>
    (
        <ContextProvider>
            <Component {...props} />
        </ContextProvider>
    );

export default compose(withContext)(SsoCallback);
